import { render, staticRenderFns } from "./ItemActivacio.vue?vue&type=template&id=3cc21a4e&"
import script from "./ItemActivacio.vue?vue&type=script&lang=js&"
export * from "./ItemActivacio.vue?vue&type=script&lang=js&"
import style0 from "./ItemActivacio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports